"use client";

import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { TtpaInfoPanel } from "@/components/cockpit/TtpaInfoPanel";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { isTtpaPageVisible } from "@/lib/module-ttpa.functions";

export const Route = createFileRoute("/_cockpit/cockpit/hundert-tage/ttpa")({
  head: () => ({
    meta: [
      { title: "TTPA-Verordnung – 100 Tage im Amt – Cockpit – creategy" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  /**
   * Ticket Z13: Die Sichtbarkeit entscheidet der Server. Bei ausgeschaltetem
   * Feature-Flag führt der direkte Aufruf zurück zur Modulübersicht; die
   * Inhaltsfunktion verweigert zusätzlich die Auslieferung.
   */
  beforeLoad: async () => {
    const visible = await isTtpaPageVisible().catch(() => false);
    if (!visible) throw redirect({ to: "/cockpit/hundert-tage" });
  },
  component: TtpaRoute,
});

function TtpaRoute() {
  return (
    <div className="space-y-6">
      <Link
        to="/cockpit/hundert-tage"
        className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden />
        Zurück zur Übersicht
      </Link>
      <CockpitPageHeader title="TTPA-Verordnung" />
      <TtpaInfoPanel />
    </div>
  );
}
